import CompletedRecallItem from './CompletedRecallItem';

export default CompletedRecallItem;
